module.exports = __webpack_public_path__ + "static/media/no_pleats.ba47a9cd.svg";